import type { Template } from "@/types";

export const PO_03_H0_V3: Template[] = [
    {
        id: "po-03-h0v3-01",
        name: "PO 01 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 122, y: 165, width: 346, height: 495, rotation: 0, imageRotation: 0 },
            { id: "2", x: 476, y: 165, width: 346, height: 495, rotation: 0, imageRotation: 0 },
            { id: "3", x: 830, y: 165, width: 346, height: 495, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-02",
        name: "PO 02 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 52, y: 133, width: 393, height: 562, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 133, width: 393, height: 562, rotation: 0, imageRotation: 0 },
            { id: "3", x: 854, y: 133, width: 392, height: 562, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-03",
        name: "PO 03 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 133, width: 428, height: 562, rotation: 0, imageRotation: 0 },
            { id: "2", x: 436, y: 133, width: 427, height: 562, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 133, width: 427, height: 562, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-04",
        name: "PO 04 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 35, y: 165, width: 346, height: 495, rotation: 0, imageRotation: 0 },
            { id: "2", x: 389, y: 41, width: 520, height: 744, rotation: 0, imageRotation: 0 },
            { id: "3", x: 918, y: 165, width: 346, height: 495, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-05",
        name: "PO 05 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 576, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 694, y: 219, width: 272, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 974, y: 219, width: 272, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-06",
        name: "PO 06 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 189, y: 219, width: 272, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 693, y: 219, width: 273, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 974, y: 219, width: 272, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-07",
        name: "PO 07 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_07.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 189, y: 0, width: 298, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 418, width: 298, height: 409, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 64, width: 487, height: 699, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-08",
        name: "PO 08 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 279, y: 67, width: 491, height: 693, rotation: 0, imageRotation: 0 },
            { id: "2", x: 778, y: 67, width: 242, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 778, y: 418, width: 242, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-09",
        name: "PO 09 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 36, y: 218, width: 284, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 218, width: 283, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 64, width: 487, height: 699, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-10",
        name: "PO 10 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 648, height: 828, rotation: 0, imageRotation: 0 },
            { id: "2", x: 713, y: 240, width: 253, height: 349, rotation: 0, imageRotation: 0 },
            { id: "3", x: 974, y: 240, width: 252, height: 349, rotation: 0, imageRotation: 0 }
        ],
    }
];